var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isContentLoaded)?_c('all-productslist',{attrs:{"allProductslist":_vm.Products}}):_vm._e(),_c('footer-menu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }